(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-details-accordions"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.accordion-block').forEach((block) => {
    const items = block.querySelectorAll('.accordion-item');

    // Initialise any item that starts open
    items.forEach((item) => {
      if (item.hasAttribute('open')) {
        const content = item.querySelector('.accordion-content');
        content.style.maxHeight = 'none';
        const height = content.scrollHeight;
        content.style.maxHeight = height + 24 + 'px';
      }
    });

    items.forEach((details) => {
      details.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = details.open;

        // Close all items
        items.forEach((item) => {
          const content = item.querySelector('.accordion-content');
          content.style.maxHeight = '0px';
          item.removeAttribute('open');
        });

        // If it wasn't open, open it
        if (!isOpen) {
          details.setAttribute('open', '');
          const content = details.querySelector('.accordion-content');

          content.style.maxHeight = 'none';
          const height = content.scrollHeight;
          content.style.maxHeight = '0px';
          content.offsetHeight;
          content.style.maxHeight = height + 24 + 'px';
        }
      });
    });

    // Variant-specific ingredients
    const ingredientVariants = block.querySelectorAll('[data-ingredient-variant]');
    if (ingredientVariants.length > 0) {
      const showVariantIngredients = (variantId) => {
        const id = String(variantId);
        ingredientVariants.forEach((el) => {
          el.style.display = el.dataset.variantId === id ? '' : 'none';
        });
        // Recompute max-height if the ingredients accordion is open
        const openItem = block.querySelector('.accordion-item[open]');
        if (openItem && openItem.querySelector('[data-ingredient-variant]')) {
          const content = openItem.querySelector('.accordion-content');
          content.style.maxHeight = 'none';
          const height = content.scrollHeight;
          content.style.maxHeight = height + 24 + 'px';
        }
      };

      document.addEventListener('variantChange', (e) => {
        showVariantIngredients(e.detail.variant.id);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
